var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRRichtext(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconR-richtext",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconR-richtext1",
    serifid: "iconR-richtext"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.133,10.1c-0.442,0 -0.8,-0.369 -0.8,-0.825c0,-0.455 0.358,-0.825 0.8,-0.825l7.195,0c0.441,0 0.799,0.37 0.799,0.825c0,0.456 -0.358,0.825 -0.799,0.825l-7.195,0Zm7.195,1.65c0.441,0 0.799,0.37 0.799,0.825c0,0.456 -0.358,0.825 -0.799,0.825l-7.195,0c-0.442,0 -0.8,-0.369 -0.8,-0.825c0,-0.455 0.358,-0.825 0.8,-0.825l7.195,0Zm-0,3.3c0.441,0 0.799,0.37 0.799,0.825c0,0.456 -0.358,0.825 -0.799,0.825l-16.789,0c-0.441,0 -0.799,-0.369 -0.799,-0.825c-0,-0.455 0.358,-0.825 0.799,-0.825l16.789,0Zm-0,3.3c0.441,0 0.799,0.369 0.799,0.825c0,0.456 -0.358,0.825 -0.799,0.825l-16.789,0c-0.441,0 -0.799,-0.369 -0.799,-0.825c-0,-0.456 0.358,-0.825 0.799,-0.825l16.789,0Zm-18.562,-4.957c-0.364,-0 -0.624,-0.122 -0.779,-0.364c-0.156,-0.243 -0.152,-0.541 0.013,-0.897l3.325,-7.288c0.139,-0.294 0.303,-0.508 0.494,-0.643c0.19,-0.134 0.411,-0.201 0.662,-0.201c0.252,0 0.472,0.067 0.663,0.201c0.191,0.135 0.351,0.349 0.481,0.643l3.351,7.288c0.165,0.364 0.171,0.665 0.02,0.903c-0.152,0.239 -0.396,0.358 -0.734,0.358c-0.295,-0 -0.522,-0.07 -0.682,-0.208c-0.16,-0.139 -0.301,-0.355 -0.422,-0.65l-0.546,-1.247l-4.274,0l-0.533,1.247c-0.13,0.303 -0.268,0.522 -0.415,0.656c-0.148,0.134 -0.356,0.202 -0.624,0.202Zm3.689,-7.133l-1.442,3.456l2.936,0l-1.468,-3.456l-0.026,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRRichtext);
export default __webpack_public_path__ + "static/media/iconR-richtext.ca3954c33a1b95bad4b69293faf124fe.svg";
export { ForwardRef as ReactComponent };